export default {
  // 通用
  '首頁': '首頁',
  '網站導覽': '網站導覽',
  ':::': ':::',
  
  // 無障礙相關
  '跳到中間主要內容區': '跳到中間主要內容區',
  '上方區塊': '上方區塊',
  '頁尾網頁資訊': '頁尾網頁資訊',
  
  // 字級設定
  '字級': '字級',
  '大': '大',
  '中': '中',
  '小': '小',
  
  // 語言選擇
  '語言選擇': '語言選擇',
  '繁體中文': '繁體中文',
  'ENGLISH': 'ENGLISH',
  '日本語': '日本語',
  
  // 社交媒體
  'FB': 'FB',
  'IG': 'IG',
  'YOUTUBE': 'YOUTUBE',
  '另開新視窗': '另開新視窗',
  '（另開新視窗）': '（另開新視窗）',
  
  // 頁尾
  'TOP': 'TOP',
  'CopyRight©2026': 'CopyRight©2026',
  
  // 導航
  'Toggle navigation': '切換導航選單',
  
  // Home 頁面
  '跳到中央內容區塊': '跳到中央內容區塊',
  '特展活動專區': '特展活動專區',
  '最新消息': '最新消息',
  'READ MORE': 'READ MORE',
  '更多最新消息（另開新視窗）': '更多最新消息（另開新視窗）',
  '活動行事曆': '活動行事曆',
  '休館': '休館',
  '有活動!': '有活動!',
  '活動': '活動',
  '活動名稱': '活動名稱',
  '活動日期': '活動日期',
  '活動地點': '活動地點',
  '未指定地點': '未指定地點',
  ' 圖片': ' 圖片',
  
  // 教案專區
  '教案專區': '教案專區',
  '登入帳號：': '登入帳號：',
  '剩餘可登入次數：': '剩餘可登入次數：',
  '剩餘時間：': '剩餘時間：',
  '登出': '登出',
  '載入中...': '載入中...',
  '教案檔案列表': '教案檔案列表',
  '#': '#',
  '檔案名稱': '檔案名稱',
  '副檔名': '副檔名',
  '檔案大小': '檔案大小',
  '操作': '操作',
  '下載': '下載',
  '下載檔案': '下載檔案',
  '目前沒有可下載的檔案': '目前沒有可下載的檔案',
  '登入時間已到，請重新登入': '登入時間已到，請重新登入',
  '無法載入檔案列表': '無法載入檔案列表',
  '載入檔案失敗，請稍後再試': '載入檔案失敗，請稍後再試',
  '下載失敗': '下載失敗',
  '下載檔案失敗，請稍後再試': '下載檔案失敗，請稍後再試',
  
  // 教案登入
  '登入': '登入',
  '電子郵件': '電子郵件',
  '請輸入電子郵件': '請輸入電子郵件',
  '密碼': '密碼',
  '請輸入密碼': '請輸入密碼',
  '隱藏密碼': '隱藏密碼',
  '顯示密碼': '顯示密碼',
  '登入中...': '登入中...',
  '請輸入電子郵件和密碼': '請輸入電子郵件和密碼',
  '請輸入有效的電子郵件格式': '請輸入有效的電子郵件格式',
  '登入失敗，請檢查您的電子郵件和密碼': '登入失敗，請檢查您的電子郵件和密碼',
  '登入失敗，請稍後再試': '登入失敗，請稍後再試',
  
  // Post 文章頁面
  '檔案下載': '檔案下載',
  '（必填）': '（必填）',
  '此表單已達填寫上限，無法繼續填寫。': '此表單已達填寫上限，無法繼續填寫。',
  '請輸入其他內容': '請輸入其他內容',
  '未選擇': '未選擇',
  '其他': '其他',
  '檔案大小限制：': '檔案大小限制：',
  'MB': 'MB',
  '允許類型：': '允許類型：',
  '最小值：': '最小值：',
  '最大值：': '最大值：',
  '送出中...': '送出中...',
  '送出': '送出',
  '分享': '分享',
  '分享至X（另開新視窗）': '分享至X（另開新視窗）',
  '分享至FB（另開新視窗）': '分享至FB（另開新視窗）',
  '驗證失敗': '驗證失敗',
  '請檢查表單內容': '請檢查表單內容',
  '確定': '確定',
  '成功！': '成功！',
  '表單已成功送出。您的資料已送出，請等候審核通知。': '表單已成功送出。您的資料已送出，請等候審核通知。',
  '表單已成功送出，感謝您的填寫。': '表單已成功送出，感謝您的填寫。',
  '錯誤': '錯誤',
  '送出失敗，請稍後再試': '送出失敗，請稍後再試',
  '連結已複製到剪貼簿': '連結已複製到剪貼簿',
  '複製失敗，請手動複製連結': '複製失敗，請手動複製連結',
  '此欄位為必填': '此欄位為必填',
  '請輸入有效的電子郵件地址': '請輸入有效的電子郵件地址',
  '請輸入有效的網址': '請輸入有效的網址',
  '輸入格式不正確': '輸入格式不正確',
  '請輸入有效的數字': '請輸入有效的數字',
  '數字不可小於': '數字不可小於',
  '數字不可大於': '數字不可大於',
  '檔案大小不可超過': '檔案大小不可超過',
  '僅允許上傳': '僅允許上傳',
  '格式的檔案': '格式的檔案',
  '檔案處理失敗，請重試': '檔案處理失敗，請重試',
  '附件': '附件',
  
  // 預約相關
  '參觀預約': '參觀預約',
  '團體預約': '團體預約',
  '導覽預約': '導覽預約',
  '預約紀錄查詢': '預約紀錄查詢',
  '【導覽解說預約須知】': '【導覽解說預約須知】',
  '隆田文化資產教育園區為全國第一座文化資產為主題之教育園區，並以「推廣臺南文化資產」、「文化資產教育資源整合」與「臺南文化資產國際交流」三大願景持續推進，提供導覽解說服務': '隆田文化資產教育園區為全國第一座文化資產為主題之教育園區，並以「推廣臺南文化資產」、「文化資產教育資源整合」與「臺南文化資產國際交流」三大願景持續推進，提供導覽解說服務',
  '辦理【團體參觀預約】者（無導覽需求），請點選【團體預約】按鈕進入申請': '辦理【團體參觀預約】者（無導覽需求），請點選【團體預約】按鈕進入申請',
  '辦理【導覽解說預約】者，請點選【導覽預約】按鈕進入申請': '辦理【導覽解說預約】者，請點選【導覽預約】按鈕進入申請',
  '整日不開放': '整日不開放',
  '已截止報名': '已截止報名',
  '本日報名已額滿': '本日報名已額滿',
  '有限制人數': '有限制人數',
  '無限制人數': '無限制人數',
  
  // 預約表單
  '您所預約的日期為：': '您所預約的日期為：',
  '年': '年',
  '月': '月',
  '日': '日',
  '預約時間': '預約時間',
  '申請單位': '申請單位',
  '請輸入申請單位': '請輸入申請單位',
  '單位類型': '單位類型',
  '學校機關': '學校機關',
  '旅行業者': '旅行業者',
  '媒體記者': '媒體記者',
  '私人企業': '私人企業',
  '公務機關': '公務機關',
  '請輸入其他類型': '請輸入其他類型',
  '貴團年齡層分布(以最大宗為主)': '貴團年齡層分布(以最大宗為主)',
  '幼稚園': '幼稚園',
  '國小': '國小',
  '國中': '國中',
  '高中': '高中',
  '大學(含研究所)': '大學(含研究所)',
  '社會人士': '社會人士',
  '樂齡長者(65歲以上)': '樂齡長者(65歲以上)',
  '團體代表姓名': '團體代表姓名',
  '請輸入參觀日聯絡人或導遊／領隊姓名': '請輸入參觀日聯絡人或導遊／領隊姓名',
  '團體代表手機': '團體代表手機',
  '請輸入參觀日聯絡人或導遊／領隊電話': '請輸入參觀日聯絡人或導遊／領隊電話',
  '參觀人數': '參觀人數',
  '(長者及6歲以下學童皆須計算人數在內)': '(長者及6歲以下學童皆須計算人數在內)',
  '申請人姓名': '申請人姓名',
  '請輸入姓名': '請輸入姓名',
  '申請人身分證字號': '申請人身分證字號',
  '請輸入身分證字號': '請輸入身分證字號',
  '申請人手機': '申請人手機',
  '請輸入手機': '請輸入手機',
  '申請人電子信箱': '申請人電子信箱',
  '請輸入電子信箱': '請輸入電子信箱',
  '預約備註': '預約備註',
  '請輸入預約備註': '請輸入預約備註',
  '※ 若無法順利媒合導覽老師，將以電子信件或電話通知，故請確認聯繫資料填寫正確': '※ 若無法順利媒合導覽老師，將以電子信件或電話通知，故請確認聯繫資料填寫正確',
  '※ 參觀當天請出示名冊並預先確認符合半票或免費入場資格者人數': '※ 參觀當天請出示名冊並預先確認符合半票或免費入場資格者人數',
  '我已經詳細閱讀並同意': '我已經詳細閱讀並同意',
  '使用規範': '使用規範',
  '使用規範（另開新視窗）': '使用規範（另開新視窗）',
  '重選日期': '重選日期',
  '確認送出': '確認送出',
  
  // 預約表單驗證訊息
  '請選擇預約時間': '請選擇預約時間',
  '請選擇單位類型': '請選擇單位類型',
  '請選擇年齡層': '請選擇年齡層',
  '請輸入團體代表姓名': '請輸入團體代表姓名',
  '請輸入團體代表手機': '請輸入團體代表手機',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '請輸入有效的手機號碼（格式：09XXXXXXXX）',
  '參觀人數須介於': '參觀人數須介於',
  '人': '人',
  '請輸入有效的台灣身分證字號': '請輸入有效的台灣身分證字號',
  '請輸入有效的電子信箱': '請輸入有效的電子信箱',
  '請閱讀並同意使用規範後再送出': '請閱讀並同意使用規範後再送出',
  '請先選擇日期': '請先選擇日期',
  '請先選擇報名類型': '請先選擇報名類型',
  '載入時段資訊失敗，請稍後再試': '載入時段資訊失敗，請稍後再試',
  '報名成功！待管理員審核後將以電子郵件通知您': '報名成功！待管理員審核後將以電子郵件通知您',
  '報名失敗，請稍後再試': '報名失敗，請稍後再試',
  '提交時發生錯誤，請稍後再試': '提交時發生錯誤，請稍後再試',
  
  // 預約查詢
  '查詢中...': '查詢中...',
  '送出查詢': '送出查詢',
  '查詢結果': '查詢結果',
  '共': '共',
  '筆': '筆',
  '查無符合的預約記錄': '查無符合的預約記錄',
  '報名編號': '報名編號',
  '報名時間': '報名時間',
  '預約日期': '預約日期',
  '預約時段': '預約時段',
  '報名類型': '報名類型',
  '審核狀態': '審核狀態',
  '待審核': '待審核',
  '已通過': '已通過',
  '未通過': '未通過',
  '未知': '未知',
  '年齡層': '年齡層',
  '無限制': '無限制',
  '備註': '備註',
  '審核時間': '審核時間',
  '審核說明': '審核說明',
  '請輸入申請人電子信箱': '請輸入申請人電子信箱',
  '請輸入申請人身分證字號': '請輸入申請人身分證字號',
  '查詢時發生錯誤，請稍後再試': '查詢時發生錯誤，請稍後再試',
  '申請人信箱': '申請人信箱',
  
  // 員工/志工登入
  '員/志工登入': '員/志工登入',
  '登入': '登入',
  '電子郵件': '電子郵件',
  '請輸入電子郵件': '請輸入電子郵件',
  '密碼': '密碼',
  '請輸入密碼': '請輸入密碼',
  '隱藏密碼': '隱藏密碼',
  '顯示密碼': '顯示密碼',
  '登入中...': '登入中...',
  '請輸入電子郵件和密碼': '請輸入電子郵件和密碼',
  '請輸入有效的電子郵件格式': '請輸入有效的電子郵件格式',
  '登入失敗，請檢查您的電子郵件和密碼': '登入失敗，請檢查您的電子郵件和密碼',
  '登入失敗，請稍後再試': '登入失敗，請稍後再試',
  
  // 網站導覽
  '網站導覽': '網站導覽',
  '網站的主要樣版內容分為三個大區塊：': '網站的主要樣版內容分為三個大區塊：',
  '(1)上方區塊 (2)中央內容區塊 (3)頁尾網頁資訊': '(1)上方區塊 (2)中央內容區塊 (3)頁尾網頁資訊',
  '本網站的導盲磚﹝Accesskey,也稱為快速鍵﹞設定如下：': '本網站的導盲磚﹝Accesskey,也稱為快速鍵﹞設定如下：',
  'Alt +U：移至網頁最上方之項目位置。': 'Alt +U：移至網頁最上方之項目位置。',
  'Alt +C：主要內容區，此區塊呈現網頁主要內容資訊。': 'Alt +C：主要內容區，此區塊呈現網頁主要內容資訊。',
  'Alt +B：下方頁尾網頁資訊。': 'Alt +B：下方頁尾網頁資訊。',
  
  // 時間票價
  '時間票價': '時間票價',
  '營業時間': '營業時間',
  '星期': '星期',
  '開館時間': '開館時間',
  '星期一': '星期一',
  '星期二': '星期二',
  '星期三': '星期三',
  '星期四': '星期四',
  '星期五': '星期五',
  '星期六': '星期六',
  '星期日': '星期日',
  '09:00 – 17:00': '09:00 – 17:00',
  '10:00 – 17:00': '10:00 – 17:00',
  '休館': '休館',
  '最後售票時間及入園時間：16:30': '最後售票時間及入園時間：16:30',
  '休園日：每週三、小年夜、除夕': '休園日：每週三、小年夜、除夕',
  '※營運調整公告：自2026年1月1日起，隆田文化資產教育園區每週固定休園日，調整為「每週三」': '※營運調整公告：自2026年1月1日起，隆田文化資產教育園區每週固定休園日，調整為「每週三」',
  '票價資訊': '票價資訊',
  '票種': '票種',
  '票價': '票價',
  '適用對象': '適用對象',
  '全票': '全票',
  '優惠票': '優惠票',
  '半票': '半票',
  '免費': '免費',
  '一般遊客': '一般遊客',
  '持有學生證在學學生。': '持有學生證在學學生。',
  '20人以上團體之成員。': '20人以上團體之成員。',
  '65歲以上長者。': '65歲以上長者。',
  '6歲以上未滿12歲之兒童。': '6歲以上未滿12歲之兒童。',
  '持有設籍於本市官田區之身分證明文件。': '持有設籍於本市官田區之身分證明文件。',
  '未滿六歲之兒童。': '未滿六歲之兒童。',
  '持有縣市政府依志願服務法之志願服務榮譽卡。': '持有縣市政府依志願服務法之志願服務榮譽卡。',
  '持有交通部觀光局核發之導遊人員執業證。': '持有交通部觀光局核發之導遊人員執業證。',
  '持有身心障礙證明，其本人與隨同1人。': '持有身心障礙證明，其本人與隨同1人。',
  '※凡購買優惠票、半票及免費票條件者，敬請出示相關證件，未攜帶者一律依全票計。': '※凡購買優惠票、半票及免費票條件者，敬請出示相關證件，未攜帶者一律依全票計。',
  '※為鼓勵乘坐大眾交通運輸工具，如於園區服務台出示 T-Pass 或當日臺鐵隆田站下車之乘車證明或車票，即可享門票優惠價（70元）購票入園！': '※為鼓勵乘坐大眾交通運輸工具，如於園區服務台出示 T-Pass 或當日臺鐵隆田站下車之乘車證明或車票，即可享門票優惠價（70元）購票入園！',
  
  // 排班相關
  '排班列表': '排班列表',
  '員工': '員工',
  '志工': '志工',
  '員/志工排班': '員/志工排班',
  '今日無勤務': '今日無勤務',
  '員工公告': '員工公告',
  '志工公告': '志工公告',
  '排班期間': '排班期間',
  '未開放排班': '未開放排班',
  '排班中': '排班中',
  '排班已截止': '排班已截止',
  '開放排班時間': '開放排班時間',
  '已送出': '已送出',
  '暫存中': '暫存中',
  '未送出': '未送出',
  '預計時數': '預計時數',
  '小時': '小時',
  '實際時數': '實際時數',
  '開始排班': '開始排班',
  '檢視排班': '檢視排班',
  '尚未開放': '尚未開放',
  '目前沒有可排班的項目': '目前沒有可排班的項目',
  '載入排班列表失敗': '載入排班列表失敗',
  '載入排班列表失敗，請稍後再試': '載入排班列表失敗，請稍後再試',
  
  // 打卡相關
  '上午打卡': '上午打卡',
  '上午打卡(下班)': '上午打卡(下班)',
  '上午打卡(完成)': '上午打卡(完成)',
  '下午打卡': '下午打卡',
  '下午打卡(下班)': '下午打卡(下班)',
  '下午打卡(完成)': '下午打卡(完成)',
  '已超過打卡時間': '已超過打卡時間',
  '上午打卡時間已過': '上午打卡時間已過',
  '未達可打卡時間': '未達可打卡時間',
  '下午打卡時間尚未到': '下午打卡時間尚未到',
  '下午打卡時間已過': '下午打卡時間已過',
  '打卡成功': '打卡成功',
  '打卡失敗': '打卡失敗',
  '打卡失敗，請稍後再試': '打卡失敗，請稍後再試',
  '確認下班': '確認下班',
  '確定要下班打卡嗎？': '確定要下班打卡嗎？',
  '系統將計算您的工作時數': '系統將計算您的工作時數',
  '已執勤：': '已執勤：',
  '分鐘': '分鐘',
  '下班打卡成功': '下班打卡成功',
  '年': '年',
  '月': '月',
  '日': '日',
  
  // 員工排班
  '員工排班表': '員工排班表',
  '剩餘需排休假日：': '剩餘需排休假日：',
  '剩餘需排例假日：': '剩餘需排例假日：',
  '可上班日': '可上班日',
  '休息日(可加班)': '休息日(可加班)',
  '例假日(不可加班)': '例假日(不可加班)',
  '員工姓名': '員工姓名',
  '注意事項': '注意事項',
  '國定假日，不可同時休假。': '國定假日，不可同時休假。',
  '*如遇天然災害，依本市公佈放假標準為原則。': '*如遇天然災害，依本市公佈放假標準為原則。',
  '暫存': '暫存',
  '返回列表': '返回列表',
  '無效的排班 ID': '無效的排班 ID',
  '載入排班資料失敗，請稍後再試': '載入排班資料失敗，請稍後再試',
  '暫存成功': '暫存成功',
  '暫存失敗': '暫存失敗',
  '休息日超過限制': '休息日超過限制',
  '休息日不足': '休息日不足',
  '例假日超過限制': '例假日超過限制',
  '例假日不足': '例假日不足',
  '確定要送出排班嗎？送出後將無法修改': '確定要送出排班嗎？送出後將無法修改',
  '取消': '取消',
  '儲存失敗': '儲存失敗',
  '儲存排班資料失敗': '儲存排班資料失敗',
  '送出成功': '送出成功',
  '您的排班已成功送出': '您的排班已成功送出',
  '已達上限': '已達上限',
  
  // 管理員工班表
  '管理員工班表': '管理員工班表',
  '管理者模式': '管理者模式',
  '管理者模式：可不受時間限制調整所有員工的排班': '管理者模式：可不受時間限制調整所有員工的排班',
  '儲存': '儲存',
  '確認儲存': '確認儲存',
  '確定要儲存所有員工的排班嗎？': '確定要儲存所有員工的排班嗎？',
  '確定儲存': '確定儲存',
  '儲存成功': '儲存成功',
  '所有員工的排班已成功儲存': '所有員工的排班已成功儲存',
  '無效的存取方式': '無效的存取方式',
  
  // 志工申請
  '志工申請': '志工申請',
  '志工申請表': '志工申請表',
  '基本資訊': '基本資訊',
  '電子信箱': '電子信箱',
  '請輸入電子信箱': '請輸入電子信箱',
  '出生年月日': '出生年月日',
  '性別': '性別',
  '男': '男',
  '女': '女',
  '身份證字號': '身份證字號',
  '請輸入身份證字號': '請輸入身份證字號',
  '照片': '照片',
  '選擇照片': '選擇照片',
  '已選擇：': '已選擇：',
  '支援格式: JPG, PNG / 檔案大小上限: 5MB': '支援格式: JPG, PNG / 檔案大小上限: 5MB',
  '學校': '學校',
  '請輸入學校名稱': '請輸入學校名稱',
  '系所': '系所',
  '請輸入系所名稱': '請輸入系所名稱',
  '肄業/畢業': '肄業/畢業',
  '請選擇': '請選擇',
  '肄業': '肄業',
  '畢業': '畢業',
  '婚姻狀況': '婚姻狀況',
  '已婚': '已婚',
  '未婚': '未婚',
  '戶籍地址': '戶籍地址',
  '請輸入戶籍地址': '請輸入戶籍地址',
  '通訊地址': '通訊地址',
  '同戶籍地址': '同戶籍地址',
  '請輸入通訊地址': '請輸入通訊地址',
  '聯絡方式': '聯絡方式',
  '住家電話': '住家電話',
  '請輸入住家電話': '請輸入住家電話',
  '辦公電話': '辦公電話',
  '請輸入辦公電話': '請輸入辦公電話',
  '手機': '手機',
  '請輸入手機號碼': '請輸入手機號碼',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ 住家電話、辦公電話、手機三者至少需填寫一個',
  '就業/就學狀況': '就業/就學狀況',
  '就業/就學狀態': '就業/就學狀態',
  '就業中': '就業中',
  '就學中': '就學中',
  '退休': '退休',
  '就業單位': '就業單位',
  '請輸入就業單位': '請輸入就業單位',
  '就讀學校': '就讀學校',
  '請輸入就讀學校': '請輸入就讀學校',
  '其他狀態說明': '其他狀態說明',
  '請說明其他狀態': '請說明其他狀態',
  '志工經驗': '志工經驗',
  '過去志工經驗': '過去志工經驗',
  '請描述過去的志工經驗': '請描述過去的志工經驗',
  '目前志工經驗': '目前志工經驗',
  '請描述目前的志工經驗': '請描述目前的志工經驗',
  '志願服務手冊': '志願服務手冊',
  '有': '有',
  '無': '無',
  '專長與興趣': '專長與興趣',
  '專長': '專長',
  '導覽解說': '導覽解說',
  '藝術文學': '藝術文學',
  '歷史人文': '歷史人文',
  '水電木工': '水電木工',
  '動物生態': '動物生態',
  '植物生態': '植物生態',
  '電腦美工': '電腦美工',
  '攝影繪圖': '攝影繪圖',
  '電腦文書': '電腦文書',
  '護理急救': '護理急救',
  '請說明其他專長': '請說明其他專長',
  '興趣': '興趣',
  '請描述您的興趣': '請描述您的興趣',
  '語言能力': '語言能力',
  '華語': '華語',
  '英語': '英語',
  '臺語': '臺語',
  '日語': '日語',
  '精通': '精通',
  '中等': '中等',
  '略懂': '略懂',
  '不會': '不會',
  '其他語言': '其他語言',
  '有其他語言能力': '有其他語言能力',
  '語言名稱': '語言名稱',
  '請選擇程度': '請選擇程度',
  '申請動機': '申請動機',
  '回饋社會，服務他人': '回饋社會，服務他人',
  '吸收藝文新知': '吸收藝文新知',
  '精神生活樂趣': '精神生活樂趣',
  '交新朋友': '交新朋友',
  '打發空閒時間': '打發空閒時間',
  '磨練自己': '磨練自己',
  '請說明其他動機': '請說明其他動機',
  '健康狀況': '健康狀況',
  '特殊疾病': '特殊疾病',
  '請說明疾病狀況': '請說明疾病狀況',
  '可服勤時段': '可服勤時段',
  '星期/時間': '星期/時間',
  '09時-12時': '09時-12時',
  '13時-16時': '13時-16時',
  '休館日': '休館日',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼',
  '其他資訊': '其他資訊',
  '自我介紹': '自我介紹',
  '請簡單介紹您自己': '請簡單介紹您自己',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': '我已經詳細閱讀個人資料使用同意書並同意相關規範',
  '下載個人資料使用同意書': '下載個人資料使用同意書',
  '返回首頁': '返回首頁',
  '文章不存在': '文章不存在',
  '確認送出': '確認送出',
  '送出中...': '送出中...',
  '照片檔案大小不得超過 5MB': '照片檔案大小不得超過 5MB',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': '請選擇有效的圖片檔案 (JPG, PNG, GIF)',
  '請輸入有效的台灣身分證字號': '請輸入有效的台灣身分證字號',
  '住家電話、辦公電話、手機三者至少需填寫一個': '住家電話、辦公電話、手機三者至少需填寫一個',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '請輸入有效的手機號碼（格式：09XXXXXXXX）',
  '請選擇就業/就學狀態': '請選擇就業/就學狀態',
  '請選擇是否有志願服務手冊': '請選擇是否有志願服務手冊',
  '請選擇華語能力': '請選擇華語能力',
  '請選擇英語能力': '請選擇英語能力',
  '請選擇臺語能力': '請選擇臺語能力',
  '請選擇日語能力': '請選擇日語能力',
  '請至少選擇一個可服勤時段': '請至少選擇一個可服勤時段',
  '請填寫自我介紹': '請填寫自我介紹',
  '請閱讀並同意相關規範後再送出': '請閱讀並同意相關規範後再送出',
  '申請成功！我們將於審核後與您聯繫': '申請成功！我們將於審核後與您聯繫',
  '申請失敗，請稍後再試': '申請失敗，請稍後再試',
  '提交時發生錯誤，請稍後再試': '提交時發生錯誤，請稍後再試',
  
  // 志工排班
  '志工排班表': '志工排班表',
  '上午場': '上午場',
  '下午場': '下午場',
  '全日': '全日',
  '星期四至星期二上午9時至12時及下午1時至4時，採兩班制。': '星期四至星期二上午9時至12時及下午1時至4時，採兩班制。',
  '*如遇天然災害，依本市公佈放假標準為原則，不另行通知。': '*如遇天然災害，依本市公佈放假標準為原則，不另行通知。',
  '逾時未打卡': '逾時未打卡',
  '打卡: ': '打卡: ',
  
  // 管理志工班表
  '管理志工班表': '管理志工班表',
  '管理者模式：可不受時間限制調整所有志工的排班，但依然會照志工的可服勤時段有所限制': '管理者模式：可不受時間限制調整所有志工的排班，但依然會照志工的可服勤時段有所限制',
  '志工姓名': '志工姓名',
  '確定要儲存所有志工的排班嗎？': '確定要儲存所有志工的排班嗎？',
  '所有志工的排班已成功儲存': '所有志工的排班已成功儲存',
  
  // 通用文字
  '天': '天',
  '請移除': '請移除',
  '還需要選擇': '還需要選擇',
  '個人資訊': '個人資訊',
  '請選擇出生年月日': '請選擇出生年月日',
  '請選擇性別': '請選擇性別',
  '請輸入身份證字號': '請輸入身份證字號',
  '請上傳照片': '請上傳照片',
  '請輸入學校': '請輸入學校',
  '請輸入系所': '請輸入系所',
  '請選擇肄業/畢業': '請選擇肄業/畢業',
  '請選擇婚姻狀況': '請選擇婚姻狀況',
  '請輸入戶籍地址': '請輸入戶籍地址',
  '請輸入通訊地址': '請輸入通訊地址',
  '請輸入就業單位': '請輸入就業單位',
  '請輸入就讀學校': '請輸入就讀學校',
  '請說明其他狀態': '請說明其他狀態',
  '請輸入語言名稱': '請輸入語言名稱',
  '請選擇語言程度': '請選擇語言程度',
  '請選擇是否有特殊疾病': '請選擇是否有特殊疾病',
  '確定送出': '確定送出',
  '休息日已達上限': '休息日已達上限',
  '例假日已達上限': '例假日已達上限',
  '無法再新增': '無法再新增',
  '的排班失敗': '的排班失敗',
  '儲存失敗，請稍後再試': '儲存失敗，請稍後再試',
  
  // 志工申請表補充翻譯
  '志工申請': '志工申請',
  '肄業/畢業': '肄業/畢業',
  '請選擇': '請選擇',
  '肄業': '肄業',
  '畢業': '畢業',
  '婚姻狀況': '婚姻狀況',
  '已婚': '已婚',
  '未婚': '未婚',
  '戶籍地址': '戶籍地址',
  '通訊地址': '通訊地址',
  '同戶籍地址': '同戶籍地址',
  '住家電話': '住家電話',
  '請輸入住家電話': '請輸入住家電話',
  '辦公電話': '辦公電話',
  '請輸入辦公電話': '請輸入辦公電話',
  '請輸入手機號碼': '請輸入手機號碼',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ 住家電話、辦公電話、手機三者至少需填寫一個',
  '就業/就學狀況': '就業/就學狀況',
  '就業/就學狀態': '就業/就學狀態',
  '就業中': '就業中',
  '就學中': '就學中',
  '退休': '退休',
  '就業單位': '就業單位',
  '就讀學校': '就讀學校',
  '其他狀態說明': '其他狀態說明',
  '請說明其他狀態': '請說明其他狀態',
  '過去志工經驗': '過去志工經驗',
  '請描述過去的志工經驗': '請描述過去的志工經驗',
  '目前志工經驗': '目前志工經驗',
  '請描述目前的志工經驗': '請描述目前的志工經驗',
  '專長': '專長',
  '請說明其他專長': '請說明其他專長',
  '興趣': '興趣',
  '請描述您的興趣': '請描述您的興趣',
  '華語': '華語',
  '英語': '英語',
  '臺語': '臺語',
  '日語': '日語',
  '精通': '精通',
  '中等': '中等',
  '略懂': '略懂',
  '不會': '不會',
  '其他語言': '其他語言',
  '有其他語言能力': '有其他語言能力',
  '語言名稱': '語言名稱',
  '特殊疾病': '特殊疾病',
  '請說明疾病狀況': '請說明疾病狀況',
  '星期/時間': '星期/時間',
  '09時-12時': '09時-12時',
  '13時-16時': '13時-16時',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼',
  '自我介紹': '自我介紹',
  '請簡單介紹您自己': '請簡單介紹您自己',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': '我已經詳細閱讀個人資料使用同意書並同意相關規範',
  '下載個人資料使用同意書': '下載個人資料使用同意書',
  '返回首頁': '返回首頁',
  '照片檔案大小不得超過 5MB': '照片檔案大小不得超過 5MB',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': '請選擇有效的圖片檔案 (JPG, PNG, GIF)',
  '請輸入有效的台灣身分證字號': '請輸入有效的台灣身分證字號',
  '請上傳照片': '請上傳照片',
  '請輸入學校': '請輸入學校',
  '請輸入系所': '請輸入系所',
  '請選擇肄業/畢業': '請選擇肄業/畢業',
  '住家電話、辦公電話、手機三者至少需填寫一個': '住家電話、辦公電話、手機三者至少需填寫一個',
  '請選擇就業/就學狀態': '請選擇就業/就學狀態',
  '請選擇是否有志願服務手冊': '請選擇是否有志願服務手冊',
  '請選擇華語能力': '請選擇華語能力',
  '請選擇英語能力': '請選擇英語能力',
  '請選擇臺語能力': '請選擇臺語能力',
  '請選擇日語能力': '請選擇日語能力',
  '請至少選擇一個可服勤時段': '請至少選擇一個可服勤時段',
  '請填寫自我介紹': '請填寫自我介紹',
  '申請成功！我們將於審核後與您聯繫': '申請成功！我們將於審核後與您聯繫',
  '申請失敗，請稍後再試': '申請失敗，請稍後再試',
  '請輸入就業單位': '請輸入就業單位',
  '請輸入就讀學校': '請輸入就讀學校',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '請輸入有效的手機號碼（格式：09XXXXXXXX）',
  '請選擇肄業/畢業': '請選擇肄業/畢業',
  '請輸入學校': '請輸入學校',
  '請輸入系所': '請輸入系所',
  '請輸入有效的台灣身分證字號': '請輸入有效的台灣身分證字號',
  '請上傳照片': '請上傳照片',
  '請輸入電子信箱': '請輸入電子信箱',
  '請輸入有效的電子信箱': '請輸入有效的電子信箱',
  '請輸入姓名': '請輸入姓名',
  '請選擇出生年月日': '請選擇出生年月日',
  '請選擇性別': '請選擇性別',
  '請輸入身份證字號': '請輸入身份證字號',
  '請選擇婚姻狀況': '請選擇婚姻狀況',
  '請輸入戶籍地址': '請輸入戶籍地址',
  '請輸入通訊地址': '請輸入通訊地址',
  '住家電話、辦公電話、手機三者至少需填寫一個': '住家電話、辦公電話、手機三者至少需填寫一個',
  '請選擇就業/就學狀態': '請選擇就業/就學狀態',
  '請說明其他狀態': '請說明其他狀態',
  '請選擇是否有志願服務手冊': '請選擇是否有志願服務手冊',
  '請選擇華語能力': '請選擇華語能力',
  '請選擇英語能力': '請選擇英語能力',
  '請輸入語言名稱': '請輸入語言名稱',
  '請選擇語言程度': '請選擇語言程度',
  '請選擇是否有特殊疾病': '請選擇是否有特殊疾病',
  '請說明疾病狀況': '請說明疾病狀況',
  '提交時發生錯誤，請稍後再試': '提交時發生錯誤，請稍後再試',
  '請閱讀並同意相關規範後再送出': '請閱讀並同意相關規範後再送出',
  '志願服務手冊': '志願服務手冊',
  '星期一': '星期一',
  '星期二': '星期二',
  '星期三': '星期三',
  '星期四': '星期四',
  '星期五': '星期五',
  '星期六': '星期六',
  '星期日': '星期日',
  '09時-12時': '09時-12時',
  '13時-16時': '13時-16時',
  '跳到中央內容區塊': '跳到中央內容區塊',
  '姓名': '姓名',

  // 新增的key
  '儲存失敗請稍後再試': '儲存失敗請稍後再試',
  '如遇天然災害，依本市公佈放假標準為原則，不另行通知': '如遇天然災害，依本市公佈放假標準為原則，不另行通知',
  '星期四至星期二上午9時至12時及下午1時至4時，採兩班制': '星期四至星期二上午9時至12時及下午1時至4時，採兩班制',
  '照片預覽': '照片預覽',
  '移除照片': '移除照片',
  '請輸入申請人姓名': '請輸入申請人姓名',
  '請輸入申請人手機': '請輸入申請人手機',
  '載入失敗': '載入失敗',
  '送出失敗': '送出失敗',
}
